import { Star, ExternalLink } from "lucide-react";

const REVIEWS = [
  {
    id: "alessandro",
    initial: "A",
    name: "Alessandro Pagliarin",
    when: "2 settimane fa",
    rating: 5,
    text:
      "Sono seguito da Christian nel mio percorso di dimagrimento e mi sto trovando bene. Sin da subito ho avuto un incontro di persona, mi ha fatto le misure della corporatura e mi ha chiesto video dei miei allenamenti per darmi consigli pratici. Non si tratta di rinunciare al cibo, ma di prestare maggiore attenzione: diversi abbinamenti, alternative per i pasti principali, e c'è anche il giorno di sgarro che mi motiva ad andare avanti. Christian mi dà la sua massima disponibilità in qualsiasi momento. Lo consiglio al 100%!",
    span: "lg:col-span-2",
  },
  {
    id: "erika",
    initial: "E",
    name: "Erika Busato",
    when: "2 mesi fa",
    rating: 5,
    text:
      "Semplicemente GRAZIE. Dopo un importante problema di salute gastrointestinale, mia figlia necessitava di prendere peso. 2 nutrizionisti non sono stati in grado. Il dott. Sacchetto invece, con pazienza e grande attenzione ed ascolto, l'ha portata al suo peso. Con conseguenze positive su fisico ed autostima. Grazie, sei il migliore.",
    badge: "Local Guide",
  },
  {
    id: "filip",
    initial: "F",
    name: "Filip Stokic",
    when: "3 settimane fa",
    rating: 5,
    text:
      "Ho conosciuto Christian tramite i social e mi ha trasmesso sin da subito professionalità, fiducia e competenza. Sono seguito da 4-5 mesi e posso dire con certezza che è stata una delle scelte migliori. Non è solo competente, è anche bravissimo ad ascoltarti: adatta il percorso alle esigenze personali. Non mi sembra di essere a dieta, l'approccio è efficace e mai stressante. Super consigliato!",
  },
  {
    id: "lucia",
    initial: "L",
    name: "Lucia Covolo",
    when: "2 mesi fa",
    rating: 5,
    text:
      "Esperienza super positiva! Un nutrizionista davvero attento ad adattare il piano ai miei gusti e alle mie esigenze, sia lavorative che legate allo sport. La dieta è sostenibile, equilibrata e mai restrittiva, quindi facile da seguire nel tempo. Sempre stimolante e spronante, con un approccio positivo e mai svalutante. Consigliatissimo!",
    span: "lg:col-span-2",
  },
];

export const GoogleReviews = () => {
  const avg = "5.0";
  const count = "Recensioni Google verificate";
  return (
    <section
      id="recensioni"
      data-testid="reviews-section"
      className="relative bg-white py-20 md:py-28 border-b border-[#E1E7E3]"
    >
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 mb-12 items-end">
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.22em] text-[#1F6E45] font-bold mb-4">
              · Recensioni clienti
            </div>
            <h2 className="font-display text-[#0E1A14] text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
              La fiducia dei miei pazienti.
              <br />
              <span className="text-[#1F6E45]">Verificata su Google.</span>
            </h2>
          </div>

          <div className="lg:col-span-5">
            <div className="bg-[#F7F9F7] border border-[#E1E7E3] rounded-2xl p-6 flex items-center gap-5">
              <GoogleG />
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <span className="font-display text-2xl text-[#0E1A14]">{avg}</span>
                  <div className="flex gap-0.5">
                    {[0, 1, 2, 3, 4].map((i) => (
                      <Star key={i} size={16} className="fill-[#F2B705] text-[#F2B705]" strokeWidth={0} />
                    ))}
                  </div>
                </div>
                <div className="text-xs text-[#6F7E76] mt-1">
                  {count}
                </div>
              </div>
              <a
                href="https://www.google.com/maps/search/?api=1&query=Sacco+Nutrizione+Viale+Quintino+Sella+35+Vicenza"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="reviews-google-link"
                className="hidden sm:inline-flex items-center gap-1.5 text-[#1F6E45] hover:text-[#144A2E] text-sm font-semibold whitespace-nowrap"
              >
                Vedi su Google <ExternalLink size={14} />
              </a>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 auto-rows-fr">
          {REVIEWS.map((r) => (
            <Review key={r.id} {...r} />
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://www.google.com/maps/search/?api=1&query=Sacco+Nutrizione+Viale+Quintino+Sella+35+Vicenza"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reviews-all-cta"
            className="inline-flex items-center gap-2 bg-[#1F6E45] text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-[#144A2E] transition-colors"
          >
            Leggi tutte le recensioni su Google
            <ExternalLink size={15} />
          </a>
          <a
            href="https://search.google.com/local/writereview?placeid=&q=Sacco+Nutrizione+Vicenza"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reviews-write-cta"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-[#C9D2CC] text-[#0E1A14] text-sm font-semibold hover:border-[#1F6E45] hover:text-[#1F6E45] transition-colors"
          >
            Lascia una recensione
          </a>
        </div>
      </div>
    </section>
  );
};

const Review = ({ id, initial, name, when, rating, text, badge, span = "" }) => (
  <article
    data-testid={`review-card-${id}`}
    className={`bg-white border border-[#E1E7E3] rounded-2xl p-6 hover:border-[#1F6E45]/40 hover:-translate-y-0.5 transition-all duration-300 soft-shadow flex flex-col ${span}`}
  >
    <div className="flex items-center gap-3 mb-4">
      <div className="w-10 h-10 rounded-full bg-[#1F6E45] text-white grid place-items-center font-bold">
        {initial}
      </div>
      <div className="flex-1">
        <div className="font-heading font-bold text-[#0E1A14] text-sm flex items-center gap-2 flex-wrap">
          {name}
          {badge && (
            <span className="text-[9px] uppercase tracking-[0.16em] bg-[#E8F2EC] text-[#1F6E45] px-1.5 py-0.5 rounded font-bold">
              {badge}
            </span>
          )}
        </div>
        <div className="text-xs text-[#6F7E76]">{when}</div>
      </div>
      <GoogleG small />
    </div>
    <div className="flex gap-0.5 mb-3">
      {Array.from({ length: rating }).map((_, i) => (
        <Star key={i} size={15} className="fill-[#F2B705] text-[#F2B705]" strokeWidth={0} />
      ))}
    </div>
    <p className="text-[#4A5A52] text-[15px] leading-relaxed">"{text}"</p>
  </article>
);

const GoogleG = ({ small = false }) => (
  <div
    className={`grid place-items-center rounded-full bg-white border border-[#E1E7E3] flex-shrink-0 ${
      small ? "w-7 h-7" : "w-12 h-12"
    }`}
    aria-label="Google"
  >
    <svg viewBox="0 0 48 48" width={small ? 14 : 22} height={small ? 14 : 22}>
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    </svg>
  </div>
);
